import React from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faFilm } from '@fortawesome/pro-regular-svg-icons';
import { CATEGORY_TYPES } from 'shared/constants';
import { useSelector } from 'react-redux';
import { getItemsByIds } from 'shared/store/selectors/knowledge.selector';
import { formatNumber } from 'shared/utils';

export function RenderMetadata({ metadata, adminMode, isCategory, styles, categoryType, options }) {
  const isKnowledgeCategory = categoryType === CATEGORY_TYPES.KNOWLEDGE;
  const knowledgeItems = options?.knowledgeItems || [];

  const knowledgeItemIds = knowledgeItems.map(item => item.id);
  const fullKnowledgeItems = useSelector(state => getItemsByIds(state.knowledge, knowledgeItemIds));

  // Only show metadata for categories/binders (items with a categoryType)
  // Don't show for regular files in communication messages
  if (_.isEmpty(metadata) || isCategory || !categoryType) return;

  let itemsCount = metadata?.items || 0;
  let mediaCount = metadata?.media || 0;

  const hasEveryRow =
    knowledgeItemIds.length > 0 && fullKnowledgeItems.length === knowledgeItemIds.length;
  if (isKnowledgeCategory && hasEveryRow) {
    const mediaItems = fullKnowledgeItems.filter(
      item => item.thumbnail && item.thumbnail !== null && item.thumbnail !== '',
    );
    const regularItems = fullKnowledgeItems.filter(
      item => !item.thumbnail || item.thumbnail === null || item.thumbnail === '',
    );

    itemsCount = regularItems.length;
    mediaCount = mediaItems.length;
  }

  const hasItems = itemsCount >= 0;
  const hasMedia = mediaCount > 0;
  const showMetadata = hasItems || hasMedia;
  const showMedia = isKnowledgeCategory && hasMedia;

  if (!adminMode && !showMetadata) return;
  return (
    <div className={styles.metadata}>
      <div className={styles.metadataContainer}>
        <FontAwesomeIcon icon={faFileInvoice} className={styles.metadataIcon} />
        <h5 className={styles.metadataText}>{formatNumber(itemsCount)}</h5>
      </div>
      {showMedia && (
        <div className={styles.metadataContainer}>
          <FontAwesomeIcon icon={faFilm} className={styles.metadataIcon} />
          <h5 className={styles.metadataText}>{formatNumber(mediaCount)}</h5>
        </div>
      )}
    </div>
  );
}
